export const convertArrayToOptions = ({ array, key, text, value = null }) => {
  return (
    array?.map((element) => ({
      key: element[key],
      text: element[text],
      value: value ? element[value] : JSON.stringify(element),
    })) || []
  );
};
